export default __webpack_public_path__ + "static/media/present.e883e2c5.svg";